import React, { ReactNode } from 'react'
import { ButtonBase, IconButton, Stack, SxProps, Theme, Typography } from '@mui/material'
import SvgIcon from '@mui/material/SvgIcon'
import { ReactComponent as CloseIcon } from '../../../assets/images/Close.svg'

type CommentsViewFilterActionButtonProps = {
    label: string
    onClick: () => void
    disabled?: boolean
}

type CommentsViewFilterClearButtonProps = {
    onClick: () => void
}

type CommentsViewFilterFieldProps = {
    label: string
    isActive?: boolean
    onClear?: () => void
    children: ReactNode
    width?: number | string
    containerSx?: SxProps<Theme>
}

export const CommentsViewFilterActionButton = ({ label, onClick, disabled }: CommentsViewFilterActionButtonProps) => {
    return (
        <ButtonBase
            disableRipple
            onClick={onClick}
            disabled={disabled}
            sx={[
                {
                    color: 'figma.primary',
                    justifyContent: 'flex-start',
                    minWidth: 0,
                    textTransform: 'uppercase',
                },
                disabled === true && { color: 'figma.grayscale.tier4', pointerEvents: 'none' },
            ]}
        >
            <Typography variant="14x600" color="inherit" sx={{ textTransform: 'uppercase', whiteSpace: 'nowrap' }}>
                {label}
            </Typography>
        </ButtonBase>
    )
}

export const CommentsViewFilterClearButton = ({ onClick }: CommentsViewFilterClearButtonProps) => (
    <IconButton
        disableRipple
        onClick={(event) => {
            event.stopPropagation()
            onClick()
        }}
        size="small"
        sx={{
            p: 0,
            color: 'figma.grayscale.textHier2',
            '&:hover': {
                backgroundColor: 'transparent',
                color: 'figma.primary',
            },
        }}
    >
        <SvgIcon component={CloseIcon} inheritViewBox color="inherit" sx={{ fontSize: '18px' }} />
    </IconButton>
)

const CommentsViewFilterField = ({
    label,
    isActive = false,
    onClear,
    children,
    width = 260,
    containerSx,
}: CommentsViewFilterFieldProps) => {
    return (
        <Stack direction="column" gap={1.5} sx={{ width: { xs: '100%', md: width }, ...containerSx }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
                <Typography
                    variant={isActive ? '18x600' : '18x500'}
                    color={isActive ? 'figma.primary' : 'figma.grayscale.textHier1'}
                >
                    {label}
                </Typography>
                {onClear && isActive && <CommentsViewFilterClearButton onClick={onClear} />}
            </Stack>
            {children}
        </Stack>
    )
}

export default CommentsViewFilterField
